import React, { useState, useEffect } from "react";
import { UserOutlined } from "@ant-design/icons";
import { FaClock, FaTrash } from "react-icons/fa";
import es_ES from "rsuite/locales/es_ES";
import {
  Calendar,
  List,
  HStack,
  Button,
  Text,
  Modal,
  Input,
  toaster,
  Message,
  SelectPicker,
  DatePicker,
  NumberInput,
  CustomProvider,
  Panel,
} from "rsuite";
import {
  getCitas,
  getHorarios,
  getPaciente,
  getPacienteXNombre,
  saveCancelCita,
  saveUpdateCita,
  getTelefonoXID,
  getListaPacientes,
  getDatosAgendaCita,
} from "./Services/ConsultasServices";
import { getCatServicios } from "./Services/HorariosServices";
import { FaBackward, FaSave } from "react-icons/fa";
import moment from "moment/moment";
import { LayoutHome } from "./LayoutHome";
import { Select } from "antd";

export const Citas = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [dataPaciente, setDataPaciente] = useState([]);
  const [lista, setLista] = useState([]);
  const [fechaCita, setFechaCita] = useState("");
  const [motivoCancel, setMotivoCancel] = useState("");
  const [dataCancel, setDataCancel] = useState("");
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setIdPacSel("0");
  };
  const [btnCancel, setBtnCancel] = useState(false);
  const [fecha, setFecha] = useState("");
  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [telefono, setTelefono] = useState("");
  const [openHor, setOpenHor] = useState(false);
  const [dataEdit, setDataEdit] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const handleCloseHorario = () => { setOpenHor(false); setIdPacSel("0") };
  const [dataHorarios, setDataHorarios] = useState([]);
  const [disableHors, setDisableHors] = useState(true);
  const [fechaHorario, setFechaHorario] = useState("");
  const [horario, setHorario] = useState("");
  const [nuevaCita, setNuevaCita] = useState(false);
  const [horNvaCita, setHorNvaCita] = useState("");
  const [message, setMessage] = useState("");
  const [disabledBtmMsj, setDisabledBtnMsj] = useState(true);
  const [espacio, setEspacio] = useState(0);
  const [currentTime] = useState(new Date());
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [horaIni, setHoraIni] = useState("");
  const [tipoHorario, setTipoHorario] = useState("");
  const [nuevoPac, setNuevoPac] = useState(false);
  const [showListaPac, setSowListaPac] = useState(true);
  const [listaPacientes, setListaPacientes] = useState([]);
  const [listServicios, setListServicios] = useState([]);
  const [idServicio, setIdServicio] = useState("1");
  const [idPacSel, setIdPacSel] = useState("");

  
  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const fetchHorarios = async (fecha) => {
    await getHorarios(idNegocio, fecha).then((nxt) => {
      setFechaHorario(fecha);
      setDataHorarios(nxt);
    });
  };

  const fetchPaciente = async (valueTel) => {
    setTelefono(valueTel);
    const response = await getPaciente(idNegocio, valueTel);
    if (response.status === 204) {
      setNuevoPac(true);
      setPaciente("");
    } else {
      if (!response.nombre) {
        setNuevoPac(true);
      } else {
        setPaciente(response.nombre);
      }
    }
  };

  const getPacientePorNombre = async (nombre) => {
    const response = await getPacienteXNombre(idNegocio);
    setDataPaciente(response);
  };

  const loadServicios = async () => {
    await getCatServicios(idNegocio).then((response) => {
      setListServicios(response);
    });
  };

  const handleChangeTelefono = async (value) => {
    setTelefono(value);
  };

  const fetchCitas = async (date) => {
    await getCitas(idNegocio, idServicio, date, "Todas").then((nxt) => {
      setLista(nxt.lstCitas);
      const citas = nxt.lstCitas;
      return citas.length;
    });
  };

  const cancelarCita = async () => {
    const datos = {
      id: idNegocio,
      idServicio: idServicio,
      espacio: espacio,
      fecha: fechaCita,
      idUser: idUser,
      motivo: motivoCancel,
    };

    if (!motivoCancel) {
      toast("Debes escribir un motivo antes de guardar", "warning");
      return;
    }

    const res = await saveCancelCita(datos);

    if (res.data === -1) {
      toast(
        "No se ha cancelado la cita, porque ya se registro la consulta.",
        "warning",
      );
      return;
    }
    if (res.data === 0) {
      toast("No se ha cancelado la cita, intente nuevamente.", "warning");
      return;
    } else {
      toast("La cita se ha cancelado de forma correcta.", "success");
      setOpen(false);
      const utcDate = moment(fecha).format("YYYY-MM-DD");
      fetchCitas(utcDate);
    }
  };

  const save = async () => {
    if (telefono.length < 10) {
      toast("Debes colocar un numero teléfóno.", "error");
      return;
    }

    if (idPaciente === "0") {
      toast("Selecciona un paciente antes de continuar.", "error");
      return;
    }

    if (tipoHorario === "horarioLibre" && !horaIni) {
      toast("El horario no puede estar vacio", "error");
      return;
    }

    if (fechaCita) {
      setFechaHorario(fecha);
      setFechaCita(fecha);
      setNuevaFecha(fecha);
    }

    const dataCita = {
      id: idNegocio,
      idServicio: idServicio,
      idPaciente: idPaciente,
      espacio: espacio,
      fechaAnterior:
        tipoHorario === "horarioLibre"
          ? nuevaFecha
          : nuevaCita
            ? fecha
            : fechaCita,
      fecha:
        tipoHorario === "horarioLibre"
          ? nuevaFecha
          : nuevaCita
            ? fecha
            : fechaHorario.substring(0, 10),
      hora: tipoHorario === "horarioLibre" ? horaIni : horario,
      nombre: paciente,
      telefono: telefono,
      correo: "",
      domicilio: "",
      edoMun: "",
      descripCita: "",
      nuevaCita: nuevaCita,
      tipoHorario: tipoHorario,
    };

    const res = await saveUpdateCita(dataCita);
    if (res.data === -1) {
      toast("El horario no se encuentra disponible.", "warning");
      return;
    }
    if (res.data === -2) {
      toast(
        "La cita no puede ser re-programada ya se ha realizado.",
        "warning",
      );
      return;
    }

    if (res.data === -3) {
      toast(
        "La cita no puede ser programada el horario esta ocupado.",
        "warning",
      );
      return;
    }

    toast("Se actualizo la cita de forma correcta", "success");
    fetchCitas(fecha);
    setDisableBtn(true);
    setDisabledBtnMsj(false);
    const utcDate = moment(fecha).format("YYYY-MM-DD");
    fetchCitas(utcDate);
    setOpenHor(false);
  };

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${message}`;
    anchor.target = "_blank";
    anchor.click();
    setOpenHor(false);
  };

  const handleSelect = (date) => {
    setIdPacSel("0");
    const _date = moment(date).format("DD/MMM/YYYY");
    const utcDate = moment(date).format("YYYY-MM-DD");
    setFecha(_date);
    fetchCitas(utcDate);
  };

  const maskTime = (value) => {
    setHoraIni(
      value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1:$2")
        .replace(/(\d{2})(\d)/, "$1:$2"),
    );
  };

  const handleEditModal = async (props) => {
    if (idPacSel === "0") {
      return;
    }
    await getDatosAgendaCita(
      idNegocio,
      idServicio,
      idPacSel,
      props.fecha,
      props.hora,
    )
      .then((res) => {
        setIdPaciente(idPacSel);
        setDisabledBtnMsj(true);
        setMessage("");
        setTipoHorario(props.opcion);
        setFechaCita(`${res.fecha} ${res.hora}`);
        setDataEdit(
          `${res.nombre} / (${res.espacio}) ${res.fecha} ${res.hora}`,
        );
        setEspacio(res.espacio);
        setTelefono(res.telefono);
        setPaciente(res.nombre);
        setNuevaCita(false);
        setNuevoPac(false);
        setOpenHor(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setDisableHors(false);

      fetchHorarios(fecha);
    } else {
      setDataHorarios([]);
    }
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  const handleHorario = (e) => {
    if (e === null) {
      setHorario("");
      setDisableBtn(true);
      setMessage("");
    } else {
      setHorario(e);
      setDisableBtn(false);
      const _hor = e.substring(0, 5);
      const _fec = moment(fechaHorario).format("DD/MM/YYYY");
      setMessage(
        `Buen día, le escribimos del ${negocio.NomConsultorio}. Confirmando su cambio de Fecha y hora de la cita para el: ${_fec} en el horario de las: ${_hor}`,
      );
    }
  };

  const handleNewCita = async (props) => {
    setListaPacientes([]);
    setIdPaciente("0");
    var fec = moment(fecha).format("DD/MM/YYYY");
    setDataEdit(`${fec}`);
    setHorario(props.hora);
    setHorNvaCita(props.hora);
    setTelefono("");
    setPaciente("");
    setMessage("");
    setHoraIni("");
    setNuevaCita(true);
    setTipoHorario(props.opcion);
    var nuevaFec = moment(props.fecha).format("YYYY-MM-DD");
    setNuevaFecha(nuevaFec);
    setNuevaCita(props.nuevaCita);
    getPacientePorNombre();
    setNuevoPac(false);
    setOpenHor(true);

    await getListaPacientes(idNegocio).then((res) => {
      setListaPacientes(res);
    });
  };

  const handleNuevoNombre = async (e) => {
    if (!e) {
      setDisableBtn(true);
      setPaciente("");
    } else {
      setDisableBtn(false);
      setPaciente(e);
    }
  };

  const handleServicio = (e) => {
    setIdServicio(e);
    setLista([]);
  };

  const hanldeNombrePaciente = async (e) => {
    if (!e) {
      setTelefono("");
      return;
    }
    if (e === "0") {
      setSowListaPac(false);
      setNuevaCita(true);
      setNuevoPac(true);
      return;
    }

    setIdPaciente(e);

    const res = await getTelefonoXID(idNegocio, e);
    if (!res) {
      setTelefono("");
    }
    if (res.telefono === undefined) {
      return;
    }

    setTelefono(res.telefono);
  };

  const handleShowModalPac = (e, props) => {
    setIdPacSel(e);
  };


  const openModalCancel = async (props) => {
    if (idPacSel === "0") {
      return;
    }
    await getDatosAgendaCita(
      idNegocio,
      idServicio,
      idPacSel,
      props.fecha,
      props.hora,
    )
      .then((res) => {
        setFechaCita(`${res.fecha} ${res.hora}`);
        setDataCancel(
          `${res.nombre} / (${res.espacio}) ${res.fecha} ${res.hora}`,
        );
        setEspacio(res.espacio);
        setBtnCancel(false);
        setOpen(true);
      })
      .catch((err) => {
        console.log(err);
        setBtnCancel(true);
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    // fetchPaciente();
    loadServicios();
    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <LayoutHome title={"Programación de Citas"} selectedKey={"6"}>
      <HStack
        spacing={10}
        style={{ height: "auto" }}
        alignItems="flex-start"
        wrap
      >
        <CustomProvider locale={es_ES}>
          <Calendar
            compact
            onSelect={handleSelect}
            style={{ width: 320 }}
            bordered
          />
        </CustomProvider>
        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE CANCELACIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          open={open}
          onClose={handleClose}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Cita: {dataCancel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row">
                <div className="col">
                  <b>Motivo</b>
                  <Input
                    as="textarea"
                    rows={4}
                    placeholder="Escriba el motivo de la cancelación de la cita."
                    onChange={(e) => setMotivoCancel(e)}
                    disabled={btnCancel}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              color="red"
              startIcon={<FaTrash></FaTrash>}
              onClick={cancelarCita}
              disabled={btnCancel}
              appearance="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleClose}
              appearance="primary"
              startIcon={<FaBackward></FaBackward>}
            >
              Regresar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO Y NUEVA CITA O RE-PROG <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size="lg"
          open={openHor}
          onClose={handleCloseHorario}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Cita: {dataEdit}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row mb-1">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <b>Nombre</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  {nuevaCita ? (
                    <SelectPicker
                      width={"100%"}
                      data={listaPacientes}
                      value={idPaciente}
                      onChange={(e) => hanldeNombrePaciente(e)}
                      searchable
                      placeholder="Selecciona un paciente..."
                      block
                    ></SelectPicker>
                  ) : (
                    <Input readOnly value={paciente} />
                  )}
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <b>Teléfono</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  <NumberInput
                    controls={false}
                    value={telefono}
                    onChange={(e) => handleChangeTelefono(e)}
                    maxLength={10}
                    min={0}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Fecha</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={moment(fecha).format("DD/MM/YYYY")}
                    />
                  ) : tipoHorario === "Reprog" ? (
                    <CustomProvider locale={es_ES}>
                      <DatePicker
                        block
                        shouldDisableDate={handleDisabledDate}
                        onChange={(e) => handleChangeFec(e)}
                      />
                    </CustomProvider>
                  ) : (
                    <Input
                      readOnly
                      value={nuevaFecha}
                      style={{ textAlign: "center" }}
                    />
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Horario</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={horNvaCita}
                      defaultValue={horNvaCita}
                    />
                  ) : tipoHorario === "Reprog" ? (
                    <SelectPicker
                      style={{ width: "auto" }}
                      block
                      searchable={false}
                      data={dataHorarios}
                      disabled={disableHors}
                      onChange={(e) => handleHorario(e)}
                      placeholder="Selecciona un horario"
                    />
                  ) : (
                    <Input
                      placeholder="00:00"
                      maxLength={5}
                      value={horaIni}
                      onChange={(e) => maskTime(e)}
                      style={{ textAlign: "center" }}
                    />
                  )}
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              appearance="primary"
              onClick={save}
              disabled={nuevaCita ? false : disableBtn}
              startIcon={<FaSave></FaSave>}
            >
              Guardar
            </Button>
            
            <Button
              onClick={handleCloseHorario}
              startIcon={<FaBackward></FaBackward>}
              appearance="primary"
            >
              Regresar
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="row">
          <Text weight="bold" size={"lg"}>
            &nbsp; &nbsp; Citas del: {fecha}
          </Text>
          <HStack style={{ padding: "5px" }} align="flex-end">
            &nbsp;
            <Select
              style={{ width: "60%" }}
              defaultValue={"1"}
              options={listServicios}
              onChange={(e) => handleServicio(e)}
              block
            />
            <Button
              appearance="primary"
              color="green"
              size="sm"
              style={{ width: "50%" }}
              disabled={idServicio === "1" ? true : false}
              onClick={() =>
                handleNewCita({
                  idPac: 0,
                  nombre: "",
                  fecha: fecha,
                  hora: "",
                  telefono: "",
                  nuevaCita: true,
                  opcion: "horarioLibre",
                })
              }
            >
              Nueva cita
            </Button>
          </HStack>
          <div className="col">
            <List
              style={{ flex: 1, fontSize: isMobile ? "12px" : "16px" }}
              bordered
            >
              {lista.map((item, index) => (
                <List.Item key={item.hora} index={item.dia}>
                  <div>
                    <b>Horario: {item.hora}</b> &nbsp;{" "}
                  </div>
                  <div
                    key={`div-disp-${index}`}
                    style={{ paddingBottom: "10px" }}
                  >
                    {item.espacio === 2 && item.estatus === "Disponible" ? (
                      <Button
                        appearance="ghost"
                        color="green"
                        title="Nueva cita"
                        size="sm"
                        onClick={() =>
                          handleNewCita({
                            idPac: item.idPac,
                            nombre: item.nombre,
                            fecha: item.fecha,
                            hora: item.hora,
                            telefono: item.telefono,
                            nuevaCita: true,
                            opcion: "horarioDisp",
                          })
                        }
                      >
                        {`${item.estatus} (${item.espacio})`}
                      </Button>
                    ) : (
                      <>
                        {item.hora < currentTime.toLocaleTimeString() &&
                        item.fecha === fecha ? (
                          <b style={{ color: "red" }}>No Disponible</b>
                        ) : (
                          <b
                            style={{
                              color:
                                item.estatus === "No Disponible" &&
                                item.espacio === 0
                                  ? "red"
                                  : "black",
                            }}
                          >
                            {item.agendadas.length > 0 ? (
                              <>
                                <HStack>
                                  <SelectPicker
                                    key={`list-agendadas-${index}`}
                                    placeholder={`Pacientes agendados (${item.agendadas.length})`}
                                    data={item.agendadas}
                                    style={{ width: "100%" }}
                                    block
                                    searchable
                                    value={idPacSel}
                                    onChange={(e) =>
                                      handleShowModalPac(e, {
                                        horario: item.hora,
                                      })
                                    }
                                  />
                                  <Button
                                    key={`btn-trash-${index}`}
                                    color="red"
                                    appearance="primary"
                                    onClick={() =>
                                      openModalCancel({
                                        fecha: item.fecha,
                                        hora: item.hora,
                                      })
                                    }
                                    size="xs"
                                    title="Cancelar cita"
                                  >
                                    <FaTrash></FaTrash>
                                  </Button>
                                  <Button
                                    key={`btn-clock-${index}`}
                                    color="primary"
                                    appearance="primary"
                                    size="xs"
                                    title="Re-programar cita"
                                    onClick={() =>
                                      handleEditModal({
                                        fecha: item.fecha,
                                        hora: item.hora,
                                        opcion: "Reprog",
                                      })
                                    }
                                  >
                                    <FaClock></FaClock>
                                  </Button>
                                </HStack>
                              </>
                            ) : (
                              ""
                            )}
                          </b>
                        )}
                      </>
                    )}
                  </div>
                  {item.espacio > 0 ? (
                    item.hora >= currentTime.toLocaleTimeString() ? (
                      <Button
                        appearance="primary"
                        color="green"
                        size="sm"
                        onClick={() =>
                          handleNewCita({
                            idPac: item.idPac,
                            nombre: item.nombre,
                            fecha: item.fecha,
                            hora: item.hora,
                            telefono: item.telefono,
                            nuevaCita: true,
                            opcion: "horarioDisp",
                          })
                        }
                      >
                        Disponible ({item.espacio})
                      </Button>
                    ) : (
                      <Button
                        appearance="primary"
                        color="green"
                        size="sm"
                        onClick={() =>
                          handleNewCita({
                            idPac: item.idPac,
                            nombre: item.nombre,
                            fecha: item.fecha,
                            hora: item.hora,
                            telefono: item.telefono,
                            nuevaCita: true,
                            opcion: "horarioDisp",
                          })
                        }
                      >
                        Disponible ({item.espacio})
                      </Button>
                    )
                  ) : (
                    ""
                  )}
                </List.Item>
              ))}
            </List>
          </div>
        </div>
        <br></br>
      </HStack>
    </LayoutHome>
  );
};
